export const defaultSelectedCategory = () => {
    return {
        categorie_code: '',
        description: '',
        line_id: '',
        subline_id: null,
    }
}

export default {

    categories: [],
    categoriesList: [],
    selectedCategory: defaultSelectedCategory(),
    error: false,
    errorMessage: '',
    action: 'create',
    actionSubcategory: 'create',
    categoryEdit: null,

    getCategoryEdit: true,

    params: {
        paginate: true,
        page: 1,
        perPage: 30,
        filter: '',
        sortBy: 'categorie_code',
        sort: 'ASC'
    }

}



// WEBPACK FOOTER //
// ./src/modules/categories/state.js